import axiosInstance from "../axios/axiosInstance";
import config from "./Config";

export default class PrestadorService {

    listAllPrestadores(data) {
        return axiosInstance.get(`${config.api.version}/prestador/${data}/get`)
    }

    getPrestador(data, id) {
        return axiosInstance.get(`${config.api.version}/prestador/${data}/get/${id}`)
    }

    getPrestadorFilter(data, search) {
        return axiosInstance.get(`${config.api.version}/prestador/${data}/get?${search}`)
    }

    postPrestador(data, prestador) {
        return axiosInstance.post(`${config.api.version}/prestador/${data}/`, prestador)
    }

    putPrestador(data, prestador, id) {
        return axiosInstance.put(`${config.api.version}/prestador/${data}/${id}`, prestador)
    }

    deletePrestador(data, id) {
        return axiosInstance.put(`${config.api.version}/prestador/${data}/delete/${id}`)
    }

    activePrestador(data, id, status) {
        return axiosInstance.put(`${config.api.version}/prestador/${data}/active/${id}/${status}`)
    }

    /// TIPO PRESTADOR
    listAllTipoPrestador(data) {
        return axiosInstance.get(`${config.api.version}/prestador/tipo/${data}/get`)
    }

    getTipoPrestador(data, id) {
        return axiosInstance.get(`${config.api.version}/prestador/tipo/${data}/get/${id}`)
    }

    postTipoPrestador(data, tipo) {
        return axiosInstance.post(`${config.api.version}/prestador/tipo/${data}/`, tipo)
    }

    putTipoPrestador(data, tipo, id) {
        return axiosInstance.put(`${config.api.version}/prestador/tipo/${data}/${id}`, tipo)
    }

    deleteTipoPrestador(data, id) {
        return axiosInstance.delete(`${config.api.version}/prestador/tipo/${data}/${id}`)
    }


}